/** Janela de edição/exclusão de mensagens (15 minutos) */
export const MESSAGE_EDIT_WINDOW_MS = 15 * 60 * 1000
